<div class="atg-image-carousel" [class.section-5]="isMultiImage$ | async">
  @if (title$ | async; as title) {
    <h2 class="carousel-title">{{ title }}</h2>
  }

  @if (carouselData$ | async; as data) {
    <div class="carousel-container">
      @if (data.slides.length > 1) {
        <button class="carousel-btn prev" (click)="prev(data.slides.length)" aria-label="Previous slide">
          <cx-icon [type]="previousIcon"></cx-icon>
        </button>
      }

      <div class="carousel-slides">
        @for (slide of data.slides; track $index; let i = $index) {
          <div class="carousel-slide" [class.active]="(currentIndex$ | async) === i">
            <div class="slide-images" [class.multi-image]="data.isMultiImage">
              @for (banner of slide; track banner.uid) {
                <div class="slide-image-item">
                  <cx-generic-link
                    [url]="banner.urlLink"
                    [target]="banner.external === 'true' ? '_blank' : null"
                  >
                    <cx-media
                      [container]="banner.media"
                      [loading]="i === 0 ? 'eager' : 'lazy'"
                      [fetchPriority]="i === 0 ? 'high' : 'auto'"
                    ></cx-media>
                    @if (banner.headline) {
                      <p class="banner-headline" [class]="getHeadlineAlignmentClass(banner)" [innerHTML]="banner.headline"></p>
                    }
                  </cx-generic-link>
                </div>
              }
            </div>
          </div>
        }
      </div>

      @if (data.slides.length > 1) {
        <button class="carousel-btn next" (click)="next(data.slides.length)" aria-label="Next slide">
          <cx-icon [type]="nextIcon"></cx-icon>
        </button>
      }
    </div>

    @if (data.slides.length > 1) {
      <div class="carousel-dots mb-3">
        @for (slide of data.slides; track $index; let i = $index) {
          <button
            class="dot"
            [class.active]="(currentIndex$ | async) === i"
            (click)="goTo(i)"
            [attr.aria-label]="'Go to slide ' + (i + 1)"
          ></button>
        }
      </div>
    }
  }
</div>
